const routes = [
    {
        path: "/esl/instructor/sessions",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "eslattendance_getinstructorsession"
        }
    }
]

export default routes;

